import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import { Icon, type IconProps } from '@/ui';

type Props = IconProps & {
  isHidden: boolean;
};

export const HiddenIcon = ({
  color = 'customgray.dark',
  boxSize = '18px',
  isHidden,
  ...props
}: Props) => {
  return isHidden ? (
    <Icon as={AiOutlineEye} boxSize={boxSize} color={color} {...props} />
  ) : (
    <Icon
      as={AiOutlineEyeInvisible}
      boxSize={boxSize}
      color={color}
      {...props}
    />
  );
};
